import React from 'react'
import jumbo from '../../assets/img/newPFOffer/jumbo.svg'

export const TopNavigatorOferta = ({data}) => {
	return (
		<div className='TopNavigator TopNavigatorOfertaNew TopNavigatorOferta'>
			<nav>
				<li>
					<h1>Oferta</h1>
					<p>{data.offer_data.promotion_name}</p>
				</li>
				<li>
					<h1>Fecha Sell-In</h1>
					<p>{data.offer_data.start_sellin} al {data.offer_data.end_sellin}</p>
				</li>
				<li > { // style={{borderLeft: '1px solid #ddd'}}
				}
					<h1>Oficinas</h1>
					<p>{
						// getImgCustomer(data.offer_data.customer, 100)
						data && data.offer_data.offices.split(",").length
					} Oficinas</p>
				</li>
				<li>
					<h1>Canal</h1>
					<p>{data.offer_data.channel}</p>
				</li>
			</nav>
		</div>
	)
}
